import ReverseExclamationIcon from './component'

export default ReverseExclamationIcon
